import {useRef,useMemo} from 'react';
import COMPONENT_MAP from '../Repository/Components.js';

// Supplies the generic ImageTab (coda_frontend/src/core/components/Repository/ImageTab.js)
// with the parent_id/table_name pair it needs to read and attach images through
// the framework's generic Attachment model - see database/models/attachment.py.
//
// useMemo + a stable executeQuery ref (matching AnalysisReportFaultDrills.js's
// ListTab wrapper / AnalysisReportFaultImage.js) - see that file's comment for
// why this is required, not optional, to avoid an unbounded refetch loop.
const AnalysisReportCycleFrameImage=({parentId,application,userData,parent,refreshToken})=>{
    const executeQuery=useRef(true);

    const renderImageTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ImageTab'];
        return Component?(
            <Component
                parentId={parentId}
                parentTable={'analysis_report_cycle_frame'}
                parent={parent}
                application={application}
                userData={userData}
                refreshToken={refreshToken}
                entityParams={['parent_id='+parentId,'table_name=analysis_report_cycle_frame','is_image=True']}
                file={'AnalysisReportCycleFrameImage.js'}
                height={'40vh'}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,refreshToken]);

    return renderImageTab;
}
export default AnalysisReportCycleFrameImage;
